<template>
    <div class="plan-header flex">
        <h1 class="plan-name">
            {{ title }}
        </h1>
        <p
            v-if="isCurrent"
            class="plan-current"
        >
            (Your current plan)
        </p>
    </div>
</template>

<script>
export default {
    props: {
        isCurrent: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            required: true,
        },
    },
};
</script>
